import { getTaskIdFromTaskKey, getTaskTitleFromTaskId } from "logic/logics";
import { useTranslation } from "react-i18next";

export default function useGetTaskTitleFromTaskKey(taskKey: string) {
  const taskId = getTaskIdFromTaskKey(taskKey);
  const { t } = useTranslation("translation", {
    keyPrefix: "task.title",
  });

  const title =
    taskKey === "dashboard"
      ? "대시보드"
      : taskKey === "thoughtmap"
      ? "나의 생각 지도"
      : taskKey === "progress"
      ? "나의 진행 상황"
      : taskKey === "payment"
      ? "월 이용권"
      : // "월 구독"
      taskKey === "chat"
      ? "채팅"
      : getTaskTitleFromTaskId(taskId);
  const postfix = taskId.includes("_") ? ` (${taskId.split("_")[1]})` : "";

  return `${t(title || "")}${postfix}`;
}
